import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storageSession from "reduxjs-toolkit-persist/lib/storage/session";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import { createTransform, persistReducer, persistStore } from "redux-persist";
import { contextSlice } from "../common/slice";
import { slices } from "../views";

const appReducer = combineReducers({ ...slices, context: contextSlice });
const rootReducer = (state, action) => {
	// Reset Store when changing project to avoid conflicts (stale data)
	if (action.type === "context/getProject/fulfilled") {
		return appReducer({ context: state.context }, action);
	}
	// Verify payload validity, cleanup context slice or reset store given the result
	if (action.type === "context/setToken") {
		const { payload } = action;
		const isValid = typeof payload === "string" && payload.includes("Bearer");
		const initialState = isValid ? state : {};
		return appReducer(initialState, { ...action, payload: isValid ? payload : null });
	}
	return appReducer(state, action);
};
const ProfilePictureFilter = createTransform(
	(inboundState, key) => {
		if (key === "context" && inboundState.user) {
			return {
				...inboundState,
				user: {
					...inboundState.user,
					profilePictureUrl: null,
				},
			};
		}
		return inboundState;
	},
	(outboundState) => outboundState,
	{ whitelist: ["context"] }
);
const persistConfig = {
	key: "root",
	storage: storageSession,
	transforms: [ProfilePictureFilter],
	stateReconciler: autoMergeLevel2,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const errorMiddleware = () => (next) => (action) => {
	if (action.type?.endsWith("rejected") && action.error?.message) {
		if (window.env.REACT_APP_ENV === "dev") {
			console.error("Message:", action.error.message);
			console.error("Stack:", action.error.stack);
			console.groupEnd();
		} else {
			console.error(action.error.message);
		}
	}
	return next(action);
};

/**
 * redux-thunk and additionnal middlewares are automatically set
 */
const store = configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}).concat(errorMiddleware),
	devTools: process.env.NODE_ENV === "development",
});

const persistor = persistStore(store);

export default { store, persistor };
